import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Button from "../Button";
import ContactForm from "../Forms/contact";
import LeadForm from "../Forms/leadForm";
import CopyBlock from "../CopyBlock";

import * as splitContentStyles from "./SplitContent.module.css";
import StaggeredTiles from "../StaggeredTiles";
import Tiles from "../Tiles";
import Video from "../Video";
import LeadMagnetMini from "../LeadMagnet/leadMagnetMini";
import LeadMagnet from "../LeadMagnet";

const SplitContent = ({
  props,
  isContainerFluid,
  size,
  moduleBackgroundColor,
}) => {
  const { backgroundColor, layout, contentLeft, contentRight, verticalAlign } =
    props;

  let _layout;
  if (!layout || layout === "50/50") {
    _layout = "half";
  } else if (layout === "1/3 - 2/3") {
    _layout = "onethird_twothirds";
  } else {
    _layout = "twothirds_onethird";
  }

  return (
    <div className={splitContentStyles.splitContent}>
      <div
        className={`${splitContentStyles.content} ${splitContentStyles[backgroundColor]} ${splitContentStyles[_layout]} ${splitContentStyles[verticalAlign]}`}
      >
        <div>
          {contentLeft.components.map((lComponent, index) => {
            const lType = lComponent?.sys?.contentType?.sys?.id;

            if (lType === "image") {
              return (
                <div
                  key={`${lComponent.id}-${index}`}
                  className={splitContentStyles.imageContainer}
                  // data-aos="fade-in"
                  // data-aos-duration="300"
                >
                  <GatsbyImage
                    className={splitContentStyles.gatsbyImage}
                    image={lComponent.file && getImage(lComponent.file)}
                    alt={lComponent.alt}
                  />
                </div>
              );
            }
            if (lType === "copyBlock") {
              return (
                <div
                  key={`${lComponent.id}-${index}`}
                  className={splitContentStyles.copyBlockContainer}
                  // data-aos="fade-up"
                  // data-aos-duration="300"
                >
                  <CopyBlock
                    props={lComponent}
                    moduleBackgroundColor={moduleBackgroundColor}
                  />
                </div>
              );
            }

            if (lType === "link") {
              return (
                <div
                  key={`${lComponent.id}-${index}`}
                  className={splitContentStyles.link}
                >
                  <Button destination={lComponent.to}>
                    {lComponent.title}
                  </Button>
                </div>
              );
            }
            if (lType === "tiles" && lComponent.variant === "staggered") {
              return (
                <div key={`${lComponent.id}-${index}`}>
                  <StaggeredTiles props={lComponent} />
                </div>
              );
            }

            if (lType === "tiles") {
              return (
                <div key={`${lComponent.id}-${index}`}>
                  <Tiles props={lComponent} />
                </div>
              );
            }

            if (lType === "form") {
              if (lComponent.type === "Contact") {
                return (
                  <div
                    key={`${lComponent.id}-${index}`}
                    className={splitContentStyles.link}
                  >
                    <ContactForm props={lComponent} />
                  </div>
                );
              } else if (lComponent.type === "Lead Form") {
                return (
                  <div
                    key={`${lComponent.id}-${index}`}
                    className={splitContentStyles.leadForm}
                  >
                    <LeadForm />
                  </div>
                );
              }
            }
            if (lType === "placeholder10") {
              return (
                <div
                  key={`${lComponent.id}-${index}`}
                  className={splitContentStyles.videoContainer}
                  // data-aos="fade-in"
                  // data-aos-duration="500"
                >
                  <Video props={lComponent} />
                </div>
              );
            }
            if (lType === "leadMagnet") {
              if (lComponent?.variant === "mini") {
                return (
                  <LeadMagnetMini
                    props={lComponent}
                    size={size}
                    /* company={props.company} */
                    isContainerFluid={true}
                  />
                );
              } else {
                return (
                  <LeadMagnet
                    props={lComponent}
                    size={size}
                    /* company={props.company} */
                    isContainerFluid={true}
                  />
                );
              }
            }
          })}
        </div>
        <div>
          {contentRight.components.map((rComponent, index) => {
            const rType = rComponent?.sys?.contentType?.sys?.id;

            if (rType === "image") {
              return (
                <div
                  key={`${rComponent.id}-${index}`}
                  className={splitContentStyles.imageContainer}
                  // data-aos="fade-in"
                  // data-aos-duration="500"
                >
                  <GatsbyImage
                    className={splitContentStyles.gatsbyImage}
                    image={rComponent.file && getImage(rComponent.file)}
                    alt={rComponent.alt}
                  />
                </div>
              );
            }
            if (rType === "copyBlock") {
              return (
                <div
                  key={`${rComponent.id}-${index}`}
                  className={splitContentStyles.copyBlockContainer}
                  // data-aos="fade-up"
                  // data-aos-duration="500"
                >
                  <CopyBlock props={rComponent} />
                </div>
              );
            }
            if (rType === "link") {
              return (
                <div
                  key={`${rComponent.id}-${index}`}
                  className={splitContentStyles.link}
                >
                  <Button destination={rComponent.to}>
                    {rComponent.title}
                  </Button>
                </div>
              );
            }
            if (rType === "tiles" && rComponent.variant === "staggered") {
              return (
                <div key={`${rComponent.id}-${index}`}>
                  <StaggeredTiles props={rComponent} />
                </div>
              );
            }

            if (rType === "tiles") {
              return (
                <div key={`${rComponent.id}-${index}`}>
                  <Tiles props={rComponent} />
                </div>
              );
            }

            if (rType === "form") {
              if (rComponent.type === "Contact") {
                return (
                  <div
                    key={`${rComponent.id}-${index}`}
                    className={splitContentStyles.link}
                  >
                    <ContactForm props={rComponent} />
                  </div>
                );
              } else if (rComponent.type === "Lead Form") {
                return (
                  <div
                    key={`${rComponent.id}-${index}`}
                    className={splitContentStyles.leadForm}
                  >
                    <LeadForm />
                  </div>
                );
              }
            }
            if (rType === "leadMagnet") {
              if (rComponent?.variant === "mini") {
                return (
                  <LeadMagnetMini
                    props={rComponent}
                    size={size}
                    /* company={props.company} */
                    isContainerFluid={true}
                  />
                );
              } else {
                return (
                  <LeadMagnet
                    props={rComponent}
                    size={size}
                    /* company={props.company} */
                    isContainerFluid={true}
                  />
                );
              }
            }
            if (rType === "placeholder10") {
              return (
                <div
                  key={`${rComponent.id}-${index}`}
                  className={splitContentStyles.videoContainer}
                  // data-aos="fade-in"
                  // data-aos-duration="500"
                >
                  <Video props={rComponent} />
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default SplitContent;
